import { useQuery, useQueryClient } from "@tanstack/react-query";
import type { JobDetailDto, JobSummaryDto } from "@workcost/shared";
import { useAuth } from "./AuthContext";
import { isMockApi } from "./estimateApi";
import { getJob, listJobs } from "./jobsApi";

/** เรียก API งานได้เมื่อเข้าสู่ระบบแล้ว (หรือโหมด mock ใน dev) */
export function useApiReady(): { ready: boolean; anonymous: boolean; loading: boolean } {
  const { status } = useAuth();
  const mock = isMockApi();
  return { ready: mock || status === "authenticated", anonymous: !mock && status === "anonymous", loading: !mock && status === "loading" };
}

export const jobsKey = ["jobs"] as const;
export const jobKey = (id: string) => ["job", id] as const;

export function useJobs() {
  const { ready } = useApiReady();
  return useQuery({ queryKey: jobsKey, queryFn: listJobs, enabled: ready, staleTime: 30_000 });
}

export function useJob(id: string) {
  const { ready } = useApiReady();
  return useQuery({ queryKey: jobKey(id), queryFn: () => getJob(id), enabled: ready && id !== "", staleTime: 30_000 });
}

/** เขียนผลที่ server ตอบกลับลง cache ของรายละเอียดงาน และทำให้รายการงานโหลดใหม่ */
export function useApplyJob() {
  const qc = useQueryClient();
  return (job: JobDetailDto) => {
    qc.setQueryData(jobKey(job.jobId), job);
    qc.setQueryData<JobSummaryDto[] | undefined>(jobsKey, (old) =>
      old?.map((j) => (j.jobId === job.jobId ? { ...j, title: job.title, customerName: job.customerName, status: job.status, progress: job.progress, grandTotal: job.grandTotal, updatedAt: job.updatedAt } : j)),
    );
    void qc.invalidateQueries({ queryKey: jobsKey });
  };
}
